import { css } from 'styled-components';

import palette from '@utils/theme/palette';

export const getButtonVariations = (isSecondaryColor?: boolean) => ({
  Default: css`
    border: 1px solid ${palette.black};
    background-color: ${palette.NL0};
    color: ${palette.black};
  `,
  Primary: css`
    background-color: ${palette.BR500};
    color: ${palette.NL0};
  `,
  Secondary: css`
    background-color: ${palette.D300};
    color: ${palette.NL0};
  `,
  Text: css`
    background-color: transparent;
    border: none;
    color: ${isSecondaryColor ? palette.D300 : palette.BR500};
  `,
  ['Primary-hover']: css`
    background-color: ${palette.BR500};
    color: ${palette.NL0};
    box-shadow: 0px 0px 20px 0px
      ${isSecondaryColor ? palette.D40 : palette.BR75};
  `,
  ['Secondary-hover']: css`
    background-color: ${palette.D300};
    color: ${palette.NL0};
    box-shadow: 0px 0px 20px 0px ${palette.D40};
  `,
  ['Outline-hover']: css`
    background-color: ${isSecondaryColor ? palette.D300 : palette.BR500};
    box-shadow: 0px 0px 20px 0px
      ${isSecondaryColor ? palette.D40 : palette.BR75};
  `,
});

export const ButtonSizes = {
  small: css`
    height: 24px;
    padding: 0px 7px;
  `,
  large: css`
    height: 40px;
    padding: 6px 15px;
  `,
};

export type ButtonVariantOptions = 'Primary' | 'Secondary' | 'Default' | 'Text';
export type ButtonSizesOptions = keyof typeof ButtonSizes;
